/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_TitleInputs */

const en_landing_faq_title = /** @type {(inputs: Landing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common questions about AI-powered job applications`)
};

const de_landing_faq_title = /** @type {(inputs: Landing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haeufige Fragen zu KI-gestuetzten Bewerbungen`)
};

const fr_landing_faq_title = /** @type {(inputs: Landing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions courantes sur les candidatures assistees par IA`)
};

const es_landing_faq_title = /** @type {(inputs: Landing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas comunes sobre solicitudes de empleo con IA`)
};

const it_landing_faq_title = /** @type {(inputs: Landing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domande comuni sulle candidature assistite dall'IA`)
};

const nl_landing_faq_title = /** @type {(inputs: Landing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veelgestelde vragen over AI-gestuurde sollicitaties`)
};

const pl_landing_faq_title = /** @type {(inputs: Landing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popularne pytania dotyczace aplikacji wspomaganych AI`)
};

const fi_landing_faq_title = /** @type {(inputs: Landing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yleisia kysymyksia tekoalyavusteisista tyohakemuksista`)
};

const da_landing_faq_title = /** @type {(inputs: Landing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almindelige sporgsmal om AI-stoettede jobansogninger`)
};

const sv_landing_faq_title = /** @type {(inputs: Landing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vanliga fraagor om AI-drivna jobbansokningar`)
};

/**
* | output |
* | --- |
* | "Common questions about AI-powered job applications" |
*
* @param {Landing_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_faq_title = /** @type {((inputs?: Landing_Faq_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_faq_title(inputs)
	if (locale === "fr") return fr_landing_faq_title(inputs)
	if (locale === "es") return es_landing_faq_title(inputs)
	if (locale === "it") return it_landing_faq_title(inputs)
	if (locale === "nl") return nl_landing_faq_title(inputs)
	if (locale === "pl") return pl_landing_faq_title(inputs)
	if (locale === "fi") return fi_landing_faq_title(inputs)
	if (locale === "da") return da_landing_faq_title(inputs)
	if (locale === "sv") return sv_landing_faq_title(inputs)
	return en_landing_faq_title(inputs)
});